import { AnalyticsProvider as CarvanaAnalyticsProvider } from '@carvana/eventable-clickstream';
import trackPerformance from '@carvana/eventable-web-vitals';
import React, { useEffect } from 'react';
import { commonEnvironment, environment } from '~/constants/environment';

type AnalyticsProviderProps = React.ComponentProps<
  typeof CarvanaAnalyticsProvider
>;

type OwnProps = React.PropsWithChildren<
  Partial<AnalyticsProviderProps> &
    Pick<AnalyticsProviderProps, 'projectName' | 'track'>
>;

export default function AnalyticsProvider({
  children,
  payloadMetaAttributes,
  projectName,
  track,
  ...rest
}: OwnProps) {
  useEffect(() => {
    trackPerformance({
      environment: commonEnvironment,
      payloadMetaAttributes,
      project: projectName,
      track
    });
  }, [payloadMetaAttributes, projectName, track]);

  return (
    <CarvanaAnalyticsProvider
      {...rest}
      environment={environment}
      payloadMetaAttributes={payloadMetaAttributes}
      projectName={projectName}
      track={track}
    >
      {children}
    </CarvanaAnalyticsProvider>
  );
}
